module.exports = __webpack_public_path__ + "static/img/收获机.e62995f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type2-2-model/收获机.png
// module id = nPPu
// module chunks = 0